import {openDialog, isOutlookPanel} from '../../../outlook/dialog';
import {isPanelInjected} from '../../loadingLine/renderLoadingPanel.react';
import {sendMessage} from '../EmbededPanelController';

export default function openScreenSettings(router, path) {
	if (isOutlookPanel()) {
		openDialog(path);
	}
	else if (isPanelInjected()) {
		sendMessage({msg: 'dativeryScreenSettings', url: path});
	}
	else {
		router.push(path);
	}
}
